import EventActionProto from '../../event-action-proto';

module.exports = class SessionMyWorkResetSortPositions extends EventActionProto {
    process() {
        gd.session.myWorkSortPositions = this.data ? this.data.sort_positions ? this.data.sort_positions : this.data : {};
    }
};